
export const getCatalogIdentificationHasLowIdentificationWarning = (catalogIdentificationPercentage: number, additionalCondition: boolean) => {
	const lowestAcceptableIdentificationPercentage = 20;
	return catalogIdentificationPercentage <= lowestAcceptableIdentificationPercentage && additionalCondition
}

export const calculateCatalogIdentificationPercentage =
	(matchingCatalogItemCount: number, previewCatalogItemCount: number, publicCatalogItemCount: number): number => {
		const currentIdentificationPercentage = matchingCatalogItemCount * 100 / Math.min(previewCatalogItemCount, publicCatalogItemCount)
		return Math.round((currentIdentificationPercentage + Number.EPSILON) * 100) / 100;
	}
